module.exports = __webpack_public_path__ + "img/Jim.c4e4e9d1.svg";